export default "__VITE_ASSET__BweH1paz__"